module.exports = __webpack_public_path__ + "montserrat-light-webfont.d95dad8d4e94a536e22b.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-light-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-light-webfont.woff
// module chunks = styles